import { render, staticRenderFns } from "./LogoAuthPages.vue?vue&type=template&id=3a5efba9&"
import script from "./LogoAuthPages.vue?vue&type=script&lang=js&"
export * from "./LogoAuthPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports